export default __webpack_public_path__ + "static/media/CR.9a03aa76.svg";